import { Action, ActionType } from "@redux/actionTypes/manpowerActionType";
import { Reducer } from "react";

export interface IManpowerState {
  manpowerDetailsByPID: IManpowerDetailsByPID[];
}

export interface IManpowerDetailsByPID {
  projectId: number;
  projectName: string;
  manpowerData: IManpowerCost;
}

interface IManpowerCost {
  headers?: Iheaders[];
  tableData: Record<string, any>[];
  total?: Record<string, any>[];
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}

const initialState = {
  manpowerDetailsByPID: [],
};

export const manpowerReducer: Reducer<IManpowerState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.MANPOWER_DETAILS_BY_PID:
      return {
        ...state,
        manpowerDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
